"use client";

import styles from "@/styles/product-detail/addon-deals.module.scss";
import Image from "next/image";

export default function AddOnInfoContent() {
  return (
    <div className={styles["privacy-content"]}>
      <div className={styles["privacy-title"]}>Super Value Add-on Deals</div>

      <div className={styles["privacy-sub-title"]}>
        <div className={styles["serial-number"]}>1</div>
        <div className={styles["sub-title-text"]}>Where to find Add-on Deals</div>
      </div>

      <div className={styles["main-text-title"]}>
        Entry 1: In your Shopping Cart
      </div>

      <Image
        className={styles["main-text-image"]}
        src={`${process.env.IMAGE_DOMAIN}/addon-deals/entry-1.png`}
        alt="addon-deals-1"
        width={496}
        height={312}
      />

      <div className={styles["main-text-title"]}>
        Entry 2: On the Product Detail page
      </div>

      <Image
        className={styles["main-text-image"]}
        src={`${process.env.IMAGE_DOMAIN}/addon-deals/entry-3.png`}
        alt="addon-deals-3"
        width={496}
        height={312}
      />

      <div className={styles["privacy-sub-title"]}>
        <div className={styles["serial-number"]}>2</div>
        <div className={styles["sub-title-text"]}>How to participate in Add-on Deals</div>
      </div>

      <div className={styles["main-text-title"]}>
        I. Introduction
      </div>

      <div className={styles["main-text"]}>
        You are eligible for "Super Value Add-on Deals" when selected items in your shopping cart meet the promotion criteria. Eligible users can purchase designated add-on products at a special discounted price.
      </div>

      <div className={styles["main-text-title"]}>
        II. Eligibility
      </div>

      <div className={styles["main-text"]}>
        1. Users must register an account on <a className={styles["link"]} href="https://www.crazysales.com.au/" target="_blank" rel="noopener noreferrer">https://www.crazysales.com.au/</a> or provide a valid email and delivery address during checkout to receive order confirmations.<br />
        2. Eligibility depends on the specific requirements displayed at the entry point of the add-on promotion in your shopping cart.
      </div>

      <div className={styles["main-text-title"]}>
        III. Access Points
      </div>

      <div className={styles["main-text"]}>
        Users can access the Add-on Deals section and select products via:

        <ul className={styles["entry-list"]}>
          <li>Below the main image on the Product Detail page.</li>
          <li>Below the "Checkout" button in the Shopping Cart.</li>
        </ul>
      </div>

      <div className={styles["main-text-title"]}>
        IV. How it Works
      </div>

      <div className={styles["main-text"]}>
        1. Adding to Cart: The Add-on Deals section will display a selection of products. Click the "Add to Cart" button next to an item to include it in your order. <br />
        2. Purchase Method: Add-on products must be purchased in the same transaction as the qualifying product. If the qualifying product is removed or not selected during checkout, the add-on eligibility and its promotional pricing will be void.<br />
        3. Purchase Limits:

        <ul className={styles["entry-list"]}>
          <li>Limit of one (1) unit per add-on product per user. This applies to the specific option selected from the add-on list.</li>
          <li>The maximum number of add-on items per order is subject to the limits displayed on the page.</li>
          <li>Stock is limited and available on a "first-come, first-served" basis. Once an add-on item is out of stock, it cannot be purchased at the promotional price even if the criteria are met. We recommend completing your purchase as soon as possible.</li>
          <li>Add-on products are not eligible for further discounts (except for no minimum spend vouchers) and do not count towards the minimum spend requirements of other promotions.</li>
          <li>While add-on items are offered at significantly discounted prices, in rare cases, the Add-on Price may be higher than the final price a customer would pay when purchasing the same item separately with applicable discounts or vouchers.</li>
        </ul>

        4. Delivery: Add-on items and main products may be dispatched separately and arrive in different shipments.
      </div>

      <div className={styles["main-text-title"]}>
        V. Terms & Conditions
      </div>

      <div className={styles["main-text"]}>
        1. Region: This promotion is exclusive to users located in Australia. <br />
        2. CrazySales.com.au reserves the right to disqualify users and, if necessary, take legal action in the following circumstances:<br />

        <ul className={styles["entry-list"]}>
          <li>Use of bots, mass registrations, or any fraudulent activity that undermines fair competition.</li>
          <li>Violations of site rules, such as credit farming, malicious cash-outs, or wash trading.</li>
          <li>Lack of genuine purchasing intent, such as abusing the refund process to obtain items at low prices followed by excessive refund requests.</li>
          <li>Any other behaviour deemed by reasonable judgement to be exploitative rather than a standard consumer purchase.</li>
        </ul>

        3. CrazySales.com.au shall be exempt from liability in cases of Force Majeure (including but not limited to natural disasters, government orders to suspend activities, or major system failures/cyber-attacks).<br />
        4.CrazySales.com.au reserves the right to adjust these rules within the scope of the law. Any changes will be updated on this page. Matters not covered here are subject to the platform’s general terms and conditions.
      </div>
    </div>
  );
}
